import { render, staticRenderFns } from "./PracticalExamDetails.vue?vue&type=template&id=911e1caa"
import script from "./PracticalExamDetails.vue?vue&type=script&lang=ts"
export * from "./PracticalExamDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports